
    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Checkmark',
        props: {
            hollow: { type: Boolean, default: false }
        }
    })
